import React, {Component} from 'react';
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";
import {MDBDataTable, MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import {Button, Checkbox, Form} from "semantic-ui-react";
import Cookies from "js-cookie";
import axiosTags from "../../../axios/axios_tag";
import * as common from "../../../const/Common/CommonFunc";
import {Icon, Spin} from "antd";
import apiConfig from "../../../axios/axios_api_services";
import DrpDwn from "../../../components/Dropdown/Dropdown/DrpDwn";
import * as tableHeaders from "../../../const/table/TableHeaders";
import axios_eventtag from "../../../axios/axios_eventtag";
import './Styles.scss';

class App extends Component {

  state = {
    data: [],
    categoryOptions: [],
    loading: false,
    selectedCategory:''
  };

  componentDidMount() {
    this.loadEventCategories()
  }

  loadEventCategories() {
    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    axios_eventtag.get(apiConfig.EVENT_CATOGARIES, {headers: headers})
      .then(response => {
        if (response.data.success) {
          if (response.data.category.length !== 0) {
            const temp = []
            response.data.category.map(item => {
              temp.push({text:item.title,value:item.event_category_id})
            })
            this.setState({ categoryOptions:temp })
          }
        }
        else {
          this.setState({ categoryOptions:[] })
        }
      })
      .catch(async error => {
        let result = await common.checkErrorResponse(error);
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  }

  selectCategory = (event, {value}) => {
    this.setState({selectedCategory: value})
    this.loadTableData(value)
  };

  loadTableData = (id) => {

    if (id !== '') {
      const headers = {
        "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
      };

      let corporateId = this.props.usr_obj.corporates[0].corporateId;

      this.props.spinnerHandler(true);
      axios_eventtag.get(apiConfig.CORPORATE_USER_CATEGORIZATION(corporateId,id), {headers: headers})
        .then(response => {
          if (response.data.success) {
            this.setState({
              data: response.data.content,
            })
          } else {
            this.setState({
              data: [],
            })
          }
        })
        .catch(async error => {
          let result = await common.checkErrorResponse(error);
          if (result === 1) {
          }
        })
        .finally(fin => {
          this.props.spinnerHandler(false);
        });
    } else {
      common.notifyMessage("Please select a category");
    }

  }


  render() {
    let rows = [];
    let all_users = this.state.data;
    if (all_users.length !== 0) {
      all_users.map((cor, index) => {
        const obj = {
          index: index + 1,
          fName: cor.firstName,
          lName: cor.lastName,
          mobile: cor.mobile,
          email: cor.email
        };
        rows.push(obj)
      })
    }

    let columns = tableHeaders.ViewAllCategorizedUser;
    let table_data = {columns, rows};

    return (
      <div className={"user-categorization-div"}>
        <Row>
          <Col lg="12">
            <Card>
              <CardHeader>
                All Users Details
              </CardHeader>
              <CardBody>
                <Row style={{marginBottom: '10px'}}>
                  <Col lg="5">
                    <Form.Group widths='equal'>
                      <DrpDwn
                        disabled={this.state.loading}
                        required
                        tagText={"Select Category"}
                        placeholder={"Select Category"}
                        value={this.state.selectedCategory}
                        options={this.state.categoryOptions}
                        onChange={this.selectCategory}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg="5" style={{paddingTop:'30px'}}>
                    <Button className="btn-style"
                      onClick={() => this.loadTableData(this.state.selectedCategory)}>Search</Button>
                  </Col>
                </Row>

                  <MDBDataTable
                    id={"all-corporate-table"}
                    searching={true}
                    searchLabel={"Search User"}
                    responsive
                    responsiveSm
                    responsiveMd
                    responsiveLg
                    responsiveXl
                    // striped={true}
                    bordered
                    hover
                    data={table_data}/>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  // usr obj
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
